<template>
	<div>
		<loading-modal v-if="isLoadingPerformanceReview" loading-text="Loading Performance Review..." />
		<div v-else>
			<div v-if="hasAccess">
				<performance-review-submit-editor 
					:logged-in-employee="loggedInEmployee"
					:performance-review="performanceReview" 
					:submit="submit" 
					:version="version"> 
				</performance-review-submit-editor>
			</div>
			<div v-else>
				You do not have access to this resource
			</div>
		</div>	
	</div>
</template>

<script>
	import { mapGetters } from 'vuex';
	import PerformanceReviewSubmitEditor from '@/components/performanceReview/PerformanceReviewSubmitEditor';
	import LoadingModal from '@/components/LoadingModal';

	export default {
		name: 'PagePerformanceReviewSubmitEdit',
		props: {
			id: {
				required: true
			},
			submitId: {
				required: true
			}
		},
		data() {
			return {
				performanceReview: null,
				isLoadingPerformanceReview: false
			};
		},
		components: {
			PerformanceReviewSubmitEditor,
			LoadingModal
		},
		computed: {
			...mapGetters({
				loggedInEmployee: 'loggedInEmployee'
			}),
			submit() {
				if (this.performanceReview != null) {
					if (this.submitId === this.performanceReview.employeeSubmit.id) {
						return this.performanceReview.employeeSubmit;
					} else if (this.submitId === this.performanceReview.reviewerSubmit.id) {
						return this.performanceReview.reviewerSubmit;
					} else return null;
				}
			},
			version() {
				if (this.performanceReview != null) {
					if (this.submitId === this.performanceReview.employeeSubmit.id) {
						return 'Employee';
					} else if (this.submitId === this.performanceReview.reviewerSubmit.id) {
						return 'Reviewer';
					}
				}
			},
			hasAccess() {
				if (this.performanceReview != null) {
					if (this.version === 'Employee') {
						return this.loggedInEmployee.id === this.performanceReview.employee.id || this.loggedInEmployee.id === this.performanceReview.reviewer.id;
					} else if (this.version === 'Reviewer') {
						return this.loggedInEmployee.id === this.performanceReview.reviewer.id;
					}
				}
				return false;
			}
		},
		async created() {
			this.$store.dispatch('setPageTitle', 'Submit Performance Review');
			
			this.isLoadingPerformanceReview = true;
			try {
				this.performanceReview = await this.$store.dispatch('performanceReviews/getById', this.id);
			} catch(err) {
				
			} finally {
				this.isLoadingPerformanceReview = false;
			}
		},
	};
</script>

<style></style>
